
import type { PropType } from 'vue'
import { computed, defineComponent } from 'vue'

export default defineComponent({
    props: {
        resources: {
            type: Array as PropType<{ weekday: number; amount: number; }[]>,
            default: () => []
        },
        usage: {
            type: Number,
            default: null
        }
    },
    setup(props) {
        const limit = computed(() => {
            let result = 0

            props.resources.forEach((resource) => {
                result = result + resource.amount
            })

            return result
        })

        return { limit }
    }
})
